/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Sync_CompleteInputs */

const en_history_sync_complete = /** @type {(inputs: History_Sync_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync completed`)
};

/**
* | output |
* | --- |
* | "Sync completed" |
*
* @param {History_Sync_CompleteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const history_sync_complete = /** @type {((inputs?: History_Sync_CompleteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Sync_CompleteInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_history_sync_complete(inputs)
});